import React from "react";
import { useState } from "@vrf/fr-vrf-core-react";
import {
  ComponentDeploymentRequestListPageContext,
  ComponentDeploymentRequestListPageInitialState,
} from ".";

export const ComponentDeploymentRequestListPageStateProvider = ({
  children,
}: any) => {
  const [pageState, setPageState] = useState(
    ComponentDeploymentRequestListPageInitialState,
  );
  const context = {
    pageState: pageState,
    setPageState: setPageState,
  };
  return (
    <ComponentDeploymentRequestListPageContext.Provider value={context}>
      {children}
    </ComponentDeploymentRequestListPageContext.Provider>
  );
};
